<template>
	<div class="Qualityserve">
		<div class="Qualityserve-top">
			<img
				:src="require('@/assets/images/Qualityserve-top.png')"
				class="image-width"
				alt=""
			/>
		</div>
		<div class="Qualityserve-mid">
			<div class="Qualityserve-mid-img">
				<img
					:src="require('@/assets/images/Qualityserve-mid.png')"
					class="image-width"
					alt=""
				/>
			</div>
		</div>
		<div class="Qualityserve-con">
			<div
				class="Qualityserve-con-item"
				v-for="(item, index) in datalist"
				:key="index"
			>
				<div class="Qualityserve-con-title">{{ item.title }}</div>
				<div class="Qualityserve-con-slef">
					<div class="con-slef-img">
						<img :src="item.img" class="image-width" alt="" />
					</div>
					<div
						:class="['con-slef-text', item.style ? '' : 'con-slef-textstya']"
					>
						{{ item.text }}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			datalist: [
				{
					title: this.$t('质量管理理念'),
					img: require('@/assets/images/Qualityserve-imga.png'),
					text: this.$t('科技创新、诚信服务、持续改进、满足用户'),
					style: true
				},
				{
					title: this.$t('生产能力'),
					img: require('@/assets/images/Qualityserve-imgb.png'),
					text: this.$t(
						'三环集团致力于先进材料的研发，可满足各行业所需的微小型及精密光电子部件、电子功能零件、新型功能材料生产应用，高新技术产品已扩大'
					)
				},
				{
					title: this.$t('研究开发'),
					img: require('@/assets/images/Qualityserve-imgc.png'),
					text: this.$t(
						'创新是企业可持续发展的强大引擎。新材料、新产品、新工艺、新设备研究、产业化、再创新的循环机制，使公司生产规模不断发展壮大，成就了三环集团“先进材料专家”的品牌优势。'
					)
				}
			]
		};
	}
};
</script>

<style lang="scss">
@use './Qualityserve.scss';
</style>
